var AuthorizedRoute = require('../mixins/authorized-route')
var Scope = require('../utils/scope')
var storage = require('storage')

module.exports = Em.Route.extend(AuthorizedRoute, {
    scopes: [Scope.BankStatementImport],

    beforeModel: function() {
        storage.remove('bank-statement-upload')
    },

    model: function() {
        return this.modelFor('bank_account')
    }
})
